import { useEffect, useState } from 'react';
import { onSnapshot } from 'firebase/firestore';
import { Transaction } from '../Model/Transaction';
import { auth, db, recurrentTransactionsPath } from '../Api';
import { collection, limit, orderBy, query, where } from 'firebase/firestore';

interface QueryConfig {
  type: 'Income' | 'Payment' | 'ALL';
  recurrent?: boolean;
  limit?: number;
}

export const useRecurrentTransactions = (config: QueryConfig) => {
  const [recurrentTransactions, setTransactions] = useState<Transaction[]>([]);
  const [isLoading, setLoading] = useState(true);
  const uid = auth.currentUser?.uid;
  const tQuery =
    config.type === 'ALL'
      ? query(collection(db, recurrentTransactionsPath(uid!)), limit(config.limit || 999), orderBy('date', 'asc'))
      : query(
          collection(db, recurrentTransactionsPath(uid!)),
          where('type', '==', config.type),
          limit(config.limit || 999),
          orderBy('date', 'asc'),
          orderBy('createdAt', 'desc'),
        );

  useEffect(() => {
    const unsub = onSnapshot(
      query(tQuery),
      documents => {
        console.log(`%cFetched Recurrent ${config.type} Transactions`, 'color:green;font-weight:bold');
        let TransactionsData: Array<Transaction> = [];
        documents.forEach(doc => {
          TransactionsData.push({
            ...(doc.data() as Transaction),
            id: doc.id,
          });
        });
        setTransactions(TransactionsData);
        setLoading(false);
      },
      error => {
        console.error(error.message);
      },
    );
    return () => {
      unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.limit, config.type, uid]);

  return { recurrentTransactions, isLoading };
};
